<template>
  <div class="flex flex-col gap-4">
    <div class="text-gray-500">
      Upload user guides, manuals, and documentation to enhance your agent's
      knowledge
    </div>
    <div class="relative">
      <el-tabs v-model="activeTab" class="">
        <el-tab-pane label="Files" name="basic">
          <EditKnowledgeFileUpload v-model="docs" />
        </el-tab-pane>
        <el-tab-pane label="Settings" name="settings">
          <EditKnowledgeSettingsSimple v-model="description" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <span class="flex flex-row justify-end">
      <el-button @click="handleCancel">Close</el-button>
      <el-button type="primary" @click="handleConfirm">Save Changes</el-button>
    </span>
  </div>
</template>

<script>
import { addOrUpdateAgent } from "@/api";
import EditKnowledgeFileUpload from "./EditKnowledgeFileUpload.vue";
import EditKnowledgeSettingsSimple from "./EditKnowledgeSettingsSimple.vue";

export default {
  name: "EditKnowledgeBaseDialog",
  components: {
    EditKnowledgeFileUpload,
    EditKnowledgeSettingsSimple,
  },
  props: {
    agent: {
      type: Object,
      default: null,
    },
  },
  data() {
    console.log("EditKnowledgeBaseDialog agent", this.agent);
    return {
      form: JSON.parse(JSON.stringify(this.agent || {})),
      activeTab: "basic",
    };
  },
  computed: {
    docs: {
      get() {
        // 找到 get_agent_knowledge function 并返回 rag.docs
        const fn = this.form?.functions?.find(
          (f) => f.function_id === "get_agent_knowledge"
        );
        return fn && fn.rag ? fn.rag.docs : [];
      },
      set(value) {
        const fn = this.form?.functions?.find(
          (f) => f.function_id === "get_agent_knowledge"
        );
        if (fn && fn.rag) {
          fn.rag.docs = value;
        }
      },
    },
    description: {
      get() {
        const fn = this.form?.functions?.find(
          (f) => f.function_id === "get_agent_knowledge"
        );
        return fn?.schema?.function?.description || "";
      },
      set(value) {
        const fn = this.form?.functions?.find(
          (f) => f.function_id === "get_agent_knowledge"
        );
        if (fn) {
          fn.schema.function.description = value;
        }
      },
    },
    agentKnowledge: {
      get() {
        const fn = this.form?.functions?.find(
          (f) => f.function_id === "get_agent_knowledge"
        );
        return fn || { schema: { function: { description: "" } } };
      },
      set(value) {
        const fn = this.form?.functions?.find(
          (f) => f.function_id === "get_agent_knowledge"
        );
        if (fn) {
          Object.assign(fn, value);
        }
      },
    },
  },
  mounted() {
    // 检查 functions 里是否有 get_agent_knowledge
    const functions = this.agent?.functions || [];
    const hasKnowledgeFn = functions.some(
      fn => fn.function_id === "get_agent_knowledge"
    );
    if (!hasKnowledgeFn) {
      this.$alert(
        "Please add a function named 'Agent Knowledge Base Search' in config, otherwise knowledge base retrieval will not be available.",
        "Knowledge Base Function Missing",
        {
          confirmButtonText: "OK",
          type: "warning",
        }
      );
    }
  },
  methods: {
    // 检查 prompt 是否包含 appendPrompt，如果没有则添加
    // 这样可以确保每次保存时都包含必要的提示信息
    // 这对于确保 agent 能正确使用知识库非常重要
    checkPrompt(prompt, append) {
      const me = this;
      if (!prompt.includes(append) && me.docs.length > 0) {
        me.form.prompt = prompt + "\n\n" + append;
      } else if (prompt.includes(append) && me.docs.length == 0) {
        me.form.prompt = prompt.replace(append, "").trim();
      }
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      const me = this;
      await addOrUpdateAgent(me.form);
      me.$emit("confirm", me.form);
    },

  },
};
</script>
